<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M20.65 10.65l-4 4a1.52 1.52 0 10.71.71l4-4a.49.49 0 10-.7-.7z"/><path d="M25.52 7.18l.72-.72.41.41a.51.51 0 00.7 0 .5.5 0 000-.71l-1.51-1.51a.5.5 0 00-.71 0 .5.5 0 000 .7l.41.41-.72.72a12.92 12.92 0 00-17.65 0 .47.47 0 00-.06-.09L5.71 5l1.14-1.15a.49.49 0 00-.7-.7l-3 3a.48.48 0 000 .7.48.48 0 00.7 0L5 5.71l1.4 1.4.09.06a13 13 0 1019 0zM16 27a11 11 0 1111-11 11 11 0 01-11 11z"/></svg>